var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center p-b-16" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("应发工资"),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "flex row-between col-center p-10",
          staticStyle: { "border-bottom": "1px solid #d4d5de" },
        },
        [
          _vm._m(0),
          _c("div", { staticClass: "font-28 font-weight-700" }, [
            _vm._v(_vm._s(_vm.boardData.salary?.actualWages) + "元"),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "flex row-between col-center p-10",
          staticStyle: { "border-bottom": "1px solid #d4d5de" },
        },
        [
          _vm._m(1),
          _c("div", { staticClass: "font-28 font-weight-700" }, [
            _vm._v(_vm._s(_vm.boardData.salary?.averageWages) + "元"),
          ]),
        ]
      ),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center p-b-16" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("绩效"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "flex row-between col-center" }, [
        _c(
          "div",
          { staticClass: "width-49 text-center bg-E2EEFC p-24 b-r-8" },
          [
            _c("img", {
              staticClass: "w-60 h-55 m-b-20",
              attrs: {
                alt: "",
                src: require("@/assets/icon/employeeKanban/kaohejixiao.png"),
              },
            }),
            _c("div", { staticClass: "font-36 font-weight-700" }, [
              _vm._v(_vm._s(_vm.boardData.performance?.averageScore)),
            ]),
            _c("div", { staticClass: "font-24 m-t-8 m-b-20" }, [
              _vm._v("平均绩效分"),
            ]),
            _c("div", { staticClass: "font-24 cor-66" }, [
              _vm._v(
                "部门排名 第" +
                  _vm._s(_vm.boardData.performance?.performanceScoreRank) +
                  "名/共" +
                  _vm._s(_vm.boardData?.unitUserNum) +
                  "人"
              ),
            ]),
          ]
        ),
        _c("div", { staticClass: "width-49" }, [
          _c("div", { staticClass: "flex-col p-20 bg-ECE9F0 m-b-20 b-r-8" }, [
            _c("img", {
              staticClass: "w-36 h-45",
              attrs: {
                alt: "",
                src: require("@/assets/icon/employeeKanban/zuigao.png"),
              },
            }),
            _c("div", { staticClass: "flex row-between col-center" }, [
              _c("span", { staticClass: "font-24" }, [
                _vm._v(
                  "最高绩效分（" +
                    _vm._s(_vm.boardData.performance?.maxScoreMonth) +
                    "月）"
                ),
              ]),
              _c("span", { staticClass: "font-36 font-weight-700" }, [
                _vm._v(_vm._s(_vm.boardData.performance?.maxScore)),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "flex-col p-20 bg-FFEDCF b-r-8" }, [
            _c("img", {
              staticClass: "w-36 h-45",
              attrs: {
                alt: "",
                src: require("@/assets/icon/employeeKanban/zuidi.png"),
              },
            }),
            _c("div", { staticClass: "flex row-between col-center" }, [
              _c("span", { staticClass: "font-24" }, [
                _vm._v(
                  "最低绩效分（" +
                    _vm._s(_vm.boardData.performance?.minScoreMonth) +
                    "月）"
                ),
              ]),
              _c("span", { staticClass: "font-36 font-weight-700" }, [
                _vm._v(_vm._s(_vm.boardData.performance?.minScore)),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "bg-FF b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center p-16" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("扣款统计"),
          ]),
        ],
        1
      ),
      _c("div", [
        _c(
          "div",
          { staticClass: "flex col-center bg-FFE6C7 p-16 m-l-16 m-r-16" },
          [
            _c("img", {
              staticClass: "w-72 h-72 m-r-16",
              attrs: {
                alt: "",
                src: require("@/assets/icon/employeeKanban/koukuan.png"),
              },
            }),
            _c("div", { staticClass: "flex row-between col-center width-90" }, [
              _c("span", { staticClass: "dis-in-b font-24" }, [
                _vm._v("扣款总金额"),
              ]),
              _c("span", { staticClass: "dis-in-b font-36 font-weight-700" }, [
                _vm._v(_vm._s(_vm.boardData.deduction?.totalDeduction)),
                _c("span", { staticClass: "font-24" }, [_vm._v(" 元")]),
              ]),
            ]),
          ]
        ),
        _c("div", { staticClass: "flex flex-wrap p-b-20" }, [
          _c(
            "div",
            {
              staticClass:
                "m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
              staticStyle: { width: "45.4%" },
            },
            [
              _vm._m(2),
              _c("div", [
                _c("div", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData.deduction?.taxDeduction)),
                  _c("span", { staticClass: "font-24" }, [_vm._v(" 元")]),
                ]),
                _c("div", { staticClass: "font-24" }, [_vm._v("个税扣款")]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
              staticStyle: { width: "45.4%" },
            },
            [
              _vm._m(3),
              _c("div", [
                _c("div", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData.deduction?.fundDeduction)),
                  _c("span", { staticClass: "font-24" }, [_vm._v(" 元")]),
                ]),
                _c("div", { staticClass: "font-24" }, [_vm._v("公积金扣款")]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
              staticStyle: { width: "45.4%" },
            },
            [
              _vm._m(4),
              _c("div", [
                _c("div", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData.deduction?.socialDeduction)),
                  _c("span", { staticClass: "font-24" }, [_vm._v(" 元")]),
                ]),
                _c("div", { staticClass: "font-24" }, [_vm._v("社保扣款")]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "m-16 bg-F5F9FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
              staticStyle: { width: "45.4%" },
            },
            [
              _vm._m(5),
              _c("div", [
                _c("div", { staticClass: "font-40 font-weight-700" }, [
                  _vm._v(_vm._s(_vm.boardData.deduction?.otherDeduction)),
                  _c("span", { staticClass: "font-24" }, [_vm._v(" 元")]),
                ]),
                _c("div", { staticClass: "font-24" }, [_vm._v("其他扣款")]),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex col-center" }, [
      _c("img", {
        staticClass: "w-28 h-28 m-r-28",
        attrs: {
          alt: "",
          src: require("@/assets/icon/employeeKanban/tablelogo.png"),
        },
      }),
      _c("div", { staticClass: "font-28" }, [_vm._v("应发工资")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex col-center" }, [
      _c("img", {
        staticClass: "w-28 h-28 m-r-28",
        attrs: {
          alt: "",
          src: require("@/assets/icon/employeeKanban/tablelogo.png"),
        },
      }),
      _c("div", { staticClass: "font-28" }, [_vm._v("平均月工资")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "item.label",
          src: require("@/assets/icon/employeeKanban/geshui.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "公积金扣款",
          src: require("@/assets/icon/employeeKanban/gongjijin.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "社保扣款",
          src: require("@/assets/icon/employeeKanban/shebao.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "其他扣款",
          src: require("@/assets/icon/employeeKanban/qita.png"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }